import { useSelector } from 'react-redux';
import { RootState, User } from '../../shared/store';

export const useUser = (): User | undefined =>
  useSelector(({ firestore }: RootState) => firestore.data.user);
